import { getLocalDate } from '@surfline/web-common';

const oneDayInSeconds = 24 * 60 * 60;

const getLocalDateFromDayNumber = (dayNumber, utcOffset) => {
  const now = new Date();
  return getLocalDate(now / 1000 + dayNumber * oneDayInSeconds, utcOffset);
};

export { getLocalDate, getLocalDateFromDayNumber };
